import React, { useEffect } from "react";
import BalloonCelebration from "../components/BalloonCelebration";
import logo from "../img/logo.png";

export default function Success() {
    useEffect(() => {
        window.history.forward();
    }, [])


    return (
        <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
            <BalloonCelebration />
            {/* <div className="max-w-xl mx-auto my-10 bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-lg shadow-sm">
                <div className="flex">
                    <svg
                        className="w-6 h-6 text-green-500 flex-shrink-0 mr-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M18.364 5.636a9 9 0 11-12.728 0m9.899-3.515a11 11 0 100 15.556m-7.071-7.071a3 3 0 104.242 4.242m-6.363 6.363a7.5 7.5 0 1010.606-10.606m-7.071-7.071a4.5 4.5 0 01-6.363 6.364"
                        />
                    </svg>
                    <div>
                        <p>Onboarding Data has been successfully submitted. You can close this window.</p>
                    </div>
                </div>
            </div> */}
			<div className="flex flex-col items-center text-center">
				<img src={logo} alt="Rize Mortgage" className="w-2/3 max-w-[480px] sm:w-1/4 sm:min-w-[280px] mb-10"/>
                <p className="text-custom-purple font-bold text-xl sm:text-2xl">
                    🎉 Congratulations and Thank You for Joining the RIZE Mortgage Family! 🎉
                </p>
                <p className="max-w-2xl text-wrap text-center font-medium text-custom-purple text-base sm:text-lg leading-relaxed mt-8">
                    Your Branch Onboarding Form has been successfully submitted, and we couldn’t be more thrilled to welcome you aboard! Our team is already gearing up to review your details and will be in touch shortly with the next steps.
                    {/* <br></br> */}
                    Get ready to embark on an exciting journey with Rize Mortgage! We’re excited to RIZE together and achieve great things. 🚀
                </p>
            </div>

        </div>
    )
}